import React, { useContext, useEffect, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes } from '../../../contexts';
import { useAggregatedState } from '../../../../helpers';

export const ReportContext = React.createContext(null);

const { Provider } = ReportContext;
export const ReportProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [ state, setState ] = useAggregatedState({
        isLoadingReports: false,
        currentReport: null
    });

    const getReportAsync = async (reportId) => {
        try {
            setState({ isLoadingReports: true });
            const reportApi = await fetchAuthorized(ApiRoutes.Report.GetReportLink({ reportLinkId: reportId }),
            {                    
                method: HttpMethods.GET
            }); 
    
            const currentReport = await reportApi.json();
            setState({ currentReport, isLoadingReports: false });
          }
    
          catch (ex){
            setState({ isLoadingReports: false });
            console.error(ex);
            console.error(ex.details);
          }
    }

    const deleteReportAsync = async (data) => {
        try {            
            await fetchAuthorized(ApiRoutes.Report.DeleteReportLink({ reportLinkId: data }),
            {                    
                method: HttpMethods.DELETE
            });
          }
    
          catch (ex){
            console.error(ex);
            console.error(ex.details);
          }
    }

    return (
        <Provider value={{
            state,
            getReportAsync,
            deleteReportAsync
        }}>
            {props.children}
        </Provider>
    );
}